export const ADD_HOME_COUNTRY_NAME = 'additional_information';
export const ADD_HOME_COUNTRY_CATEGORY = 'Additional Information';
export const ADD_MOBILEPHONE_NAME = 'add_mobile_phone';
export const ADD_MOBILEPHONE_CATEGORY = 'Add Mobile Phone';
export const AUO_WELCOME_NAME = 'auo_welcome';
export const AUO_WELCOME_CATEGORY = 'AUO Welcome';
export const AUO_WELCOME_INSTRUCTOR_NAME = 'auo_welcome_instructor';
export const AUO_WELCOME_INSTRUCTOR_CATEGORY = 'AUO Welcome Instructor';
export const CHOOSE_ACCOUNT_TYPE_NAME = 'choose_account_type';
export const CHOOSE_ACCOUNT_TYPE_CATEGORY = 'Choose Account Type';
export const CODE_HELP_NAME = 'code_help';
export const CODE_HELP_CATEGORY = 'Code Help';
export const CREATE_ACCOUNT_NAME = 'create_account';
export const CREATE_ACCOUNT_CATEGORY = 'Create Account';
export const CREATE_PW_NAME = 'create_password';
export const CREATE_PW_CATEGORY = 'Create Your Password';
export const FORGOT_USERNAME_OR_PASSWORD_NAME = 'forgot_username_or_password';
export const FORGOT_USERNAME_OR_PASSWORD_CATEGORY = 'Forgot Your Username or Password';
export const LINK_ACCOUNTS_NAME = 'link_accounts';
export const LINK_ACCOUNTS_CATEGORY = 'Link Accounts';
export const MFA_NAME = 'mfa_for_recaptcha';
export const MFA_CATEGORY = 'MFA for reCAPTCHA';
export const MFA_VERIFY_EMAIL_NAME = 'mfa_check_your_email';
export const MFA_VERIFY_EMAIL_CATEGORY = 'MFA Check Your Email';
export const MFA_VERIFY_MOBILE_PHONE_NAME = 'mfa_check_your_phone';
export const MFA_VERIFY_MOBILE_PHONE_CATEGORY = 'MFA Check Your Phone';
export const RECAPTCHA_FAILED_CATEGORY = 'Recaptcha Failed';
export const RESET_PASSWORD_NAME = 'reset_password';
export const RESET_PASSWORD_CATEGORY = 'Reset Your Password';
export const RESET_PASSWORD_LINKS_NAME = 'reset_password_links';
export const RESET_PASSWORD_LINKS_CATEGORY = 'Reset Your Password Links';
export const RESET_PW_CONFIRMATION_NAME = 'reset_password';
export const RESET_PW_CONFIRMATION_CATEGORY = 'Reset Your Password';
export const SIGNIN_NAME = 'signin';
export const SIGNIN_CATEGORY = 'Sign In';
export const SIGNIN_CODE_NAME = 'signin_code';
export const SIGNIN_CODE_CATEGORY = 'Sign In Code';
export const SIGNIN_CODE_OPTIONS_NAME = 'signin_code_options';
export const SIGNIN_CODE_OPTIONS_CATEGORY = 'Sign In Code Options';
export const USER_INTERACTION_NAME = 'user_interaction';
export const VERIFY_MOBILE_PHONE_NAME = 'check_your_phone';
export const VERIFY_MOBILE_PHONE_CATEGORY = 'Check Your Phone';
export const VERIFY_MOBILE_PHONE_FOR_FORGOT_NAME = 'check_your_phone_for_forgot';
export const VERIFY_MOBILE_PHONE_FOR_FORGOT_CATEGORY = 'Check Your Phone For Forgot';
export const VERIFY_SIGNIN_CODE_NAME = 'verify_signin_code';
export const VERIFY_SIGNIN_CODE_CATEGORY = 'Verify Sign In Code';
